import { gql } from "@apollo/client";

export const GET_EXPENSE_CATEGORIES_OF_TYPE = gql`
  query expenseCategories($type: ExpenseCategoryType) {
    expenseCategories(type: $type) {
      id
      name
      level
      accountSystem
      accountCategoryId
      accountCategory
      accountCategorySearchTerm
    }
  }
`;

export const GET_EXPENSE_CATEGORY_OPTIONS = gql`
  query expenseCategories($selectedCompanyId: ID) {
    expenseCategories(selectedCompanyId: $selectedCompanyId) {
      id
      name
      level
    }
  }
`;
